module.exports = __webpack_public_path__ + "img/zhiying.c31295a9.svg";